import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraText } from '@mono/ui-components/ensigns';
import { recordDocumentRow, recordDocumentsSection } from '../../documents/recordDocumentsSection';
// "24 Oct" (d MMM), stable across runtimes.
const shortDay = (d)=>`${d.getUTCDate()} ${d.toLocaleDateString('en-US', {
        month: 'short',
        timeZone: 'UTC'
    })}`;
const muted = (text)=>/*#__PURE__*/ _jsx(SpecraText, {
        as: "p",
        size: "body-ui",
        tone: "muted",
        children: text
    });
/** Rail: Who knows them · What they care about (+ hearsay) · Documents. */ export function contactRail(dossier, docs, opts = {}) {
    const whoKnows = {
        id: 'who-knows',
        title: 'Who knows them',
        rows: dossier.whoKnows.map((w)=>({
                id: w.id,
                label: w.name,
                value: /*#__PURE__*/ _jsxs(SpecraText, {
                    size: "meta",
                    tone: "muted",
                    children: [
                        w.meetingCount === 0 && w.contextHint ? w.contextHint : `${w.meetingCount} ${w.meetingCount === 1 ? 'meeting' : 'meetings'}`,
                        w.lastMetAt ? ` · last ${shortDay(w.lastMetAt)}` : ''
                    ]
                })
            })),
        children: dossier.whoKnows.length === 0 ? muted('No meetings with your team recorded yet.') : undefined
    };
    const hasInterests = dossier.interests.length > 0;
    const cares = {
        id: 'cares-about',
        title: 'What they care about',
        rows: dossier.interests.map((i)=>({
                id: i.id,
                label: i.statement,
                value: /*#__PURE__*/ _jsx(SpecraText, {
                    size: "meta",
                    tone: "muted",
                    children: i.sourceText
                })
            })),
        children: opts.claims ?? (hasInterests ? undefined : muted('Nothing recorded about them yet.'))
    };
    const entity = {
        kind: 'CONTACT',
        id: dossier.id
    };
    const docsSection = recordDocumentsSection(entity, (docs?.documents ?? []).map((d)=>recordDocumentRow(entity, {
            key: d.id,
            artifactId: d.artifactId,
            title: d.filename,
            href: d.href,
            homeLabel: d.homeLabel,
            unlinkable: d.unlinkable
        })), docs?.canLink ?? false);
    return [
        whoKnows,
        cares,
        docsSection
    ];
}
